import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Plyr from 'plyr/dist/plyr.polyfilled.js'

import helper from './helper'

gsap.registerPlugin(ScrollTrigger)

let plyrOptions = {
    iconUrl: '',
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen',
    ],
}

let playersArray = []
// const player = new Plyr('#player');
const players = Array.from(document.querySelectorAll('.js-player')).map(p => {
    const player = new Plyr(p, plyrOptions)
    playersArray.push(player)
    player.on('ready', event => {
        const instance = event.detail.plyr
        setTimeout(() => {
            $(instance.media).closest('.plyr--video').addClass('plyr--ready')
            $(instance.media)
                .closest('.plyr--video')
                .attr('data-plyr-id', player.id)
        }, 800)
    })
})
window.players = players

$(document).ready(() => {
    $('.plyr__control--overlaid').on('click', event => {
        let id = $(event.target).parent().data('plyr-id'),
            currentVideo = playersArray.filter(video => video.id === id)[0]
    
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            currentVideo.play()
        } else {
            playersArray.forEach(item => {
                item.pause()
            })
            const $trigger = $(event.currentTarget).parent().find('.js-player')
    
            const $video = $(
                '<div class="video-wrapper">' +
                    '<video class="js-player">' +
                    '<source src="' +
                    $trigger.data('video-src') +
                    '" type="video/mp4">' +
                    '</video>' +
                    '</div>'
            )
    
            $('.js-popup-content', helper.$modal).html($video)
    
            const modalPlayer = new Plyr(
                $('.js-player', helper.$modal).get(0),
                plyrOptions
            )
    
            helper.$modal.addClass('reveal-video').foundation('open')
            helper.$modal.closest('.reveal-overlay').addClass('has-transparency')
            modalPlayer.togglePlay()
        }
    })
})

// $(document).on('click', '.js-play-in-modal', event => {
//     const $trigger = $(event.currentTarget)
//     const $video = $(
//         '<div class="video-wrapper">' +
//             '<div class="js-player" data-plyr-provider="vimeo" data-plyr-embed-id="' +
//             $trigger.data('video') +
//             '"></div>' +
//             '</div>'
//     )

//     $('.js-popup-content', helper.$modal).html($video)

//     // plyrOptions.autoplay = true
//     const modalPlayer = new Plyr(
//         $('.js-player', helper.$modal).get(0),
//         plyrOptions
//     )

//     helper.$modal.addClass('reveal-video').foundation('open')
//     helper.$modal.closest('.reveal-overlay').addClass('has-transparency')
//     modalPlayer.togglePlay()
// })

helper.$modal.on('open.zf.reveal', () => {
    const pageTriggers = ScrollTrigger.getAll()
    pageTriggers.forEach(trigger => {
        trigger.disable(false)
    })
})

helper.$modal.on('closed.zf.reveal', () => {
    helper.$modal.closest('.reveal-overlay').removeClass('has-transparency')
    helper.$modal.removeClass('reveal-video')
    $('.js-popup-content', helper.$modal).empty()

    const pageTriggers = ScrollTrigger.getAll()
    pageTriggers.forEach(trigger => {
        trigger.enable()
    })
    setTimeout(() => ScrollTrigger.refresh(), 400)
})
